const ShortlistHeader = ({
  onlySoldVehicles,
  shortlist,
}: {
  onlySoldVehicles: boolean;
  shortlist: string[];
}): JSX.Element => (
  <h1 className="ch-fs--5 sm:ch-fs--6 ch-mv--4">
    {onlySoldVehicles
      ? 'All of your shortlisted vehicles have now sold'
      : `${shortlist.length} ${
          shortlist.length === 1 ? 'vehicle' : 'vehicles'
        } in your shortlist`}
  </h1>
);

export default ShortlistHeader;
